import * as Types from '../actions/action.types';
import { ActionType } from '../infrastructure/call.api';

export const defaultState = {
	appName: 'Tracks-Office' as string,
	appVersion: '1.0.0' as string,
	clockEntryUrl: null as string,
	appType: 'dev' as string,
	redirectUserName: null as string,
	redirectUrl: null as string,
	isMobileMode: false,
	processing: false,
	isBrowserRegistered: false,
	turnOnForgotPassword: false,
	showForgotUsernameMessage: false,
	forgotUsernameMessage: null as string,
	onlySSOLoginAllowed: null as boolean,
	urlForNotAppropriateUser: null as string,
};
export type ReducerState = typeof defaultState;
export function reducer(state = defaultState, action: any): ReducerState {
	switch (action.type) {
		case Types.LOAD_INITIAL_DATA: {
			let payload = action.payload as Types.LOAD_INITIAL_DATA_PAYLOAD;
			return {
				...state,
				appName: payload.appName,
				appVersion: payload.appVersion,
				clockEntryUrl: payload.clockEntryUrl,
				appType: payload.appType,
				redirectUrl: payload.redirectUrl,
				redirectUserName: payload.redirectUserName,
				turnOnForgotPassword: payload.turnOnForgotPWD,
				isBrowserRegistered: payload.isBrowserRegistered,
				forgotUsernameMessage: payload.forgotUserNameMessage,
				onlySSOLoginAllowed: payload.onlySSOLoginAllowed,
				urlForNotAppropriateUser: payload.urlForNotAppropriateUser,
			};
		}
		case Types.CHANGE_BROWSER_REGISTRATION: {
			let payload = action.payload as Types.CHANGE_BROWSER_REGISTRATION_PAYLOAD;
			return { ...state, isBrowserRegistered: payload };
		}
		case Types.REFRESH_APP_WINDOW_SIZE: {
			let payload = action.payload as Types.REFRESH_APP_WINDOW_SIZE_PAYLOAD;
			return {
				...state,
				isMobileMode: payload.isMobileMode,
			};
		}
		case Types.PWD_EXPIRED_PENDING:
		case Types.PWD_RECOVERY_PENDING: {
			return {
				...state,
				processing: true,
			};
		}
		case Types.PWD_EXPIRED_RESET_PASSWORD:
		case Types.PWD_RECOVERY_SET_QUESTIONS:
		case ActionType.REQUEST_FINISHED:
		case Types.PWD_RECOVERY_CHECK_ANSWERS: {
			return {
				...state,
				processing: false,
			};
		}
		case Types.SHOW_FORGOT_USERNAME_MESS: {
			return {
				...state,
				showForgotUsernameMessage: !state.showForgotUsernameMessage,
			};
		}
		default:
			return state;
	}
}
